import { Component } from "vue-property-decorator"

import FSwitchBase from "./fSwitch.client.base"

@Component
export default class FSwitchWeb extends FSwitchBase {}
